import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { type Task } from "@/services/task.service";
import { type Project } from "@/services/project.service";
import { type ColumnDef } from "./columns";

export default function TaskReportsTable({
	tasks,
	projects,
	columns,
}: {
	tasks: Task[];
	projects: Project[];
	columns: ColumnDef[];
}) {
	const ctx = { projects };

	return (
		<Card className="p-0 overflow-x-auto">
			<table className="w-full text-sm">
				<thead>
					<tr className="border-b border-border bg-muted-subtle/40">
						{columns.map((col, i) => (
							<th
								key={col.key}
								className={cn(
									"px-4 py-3 text-left text-[10px] font-medium uppercase tracking-wider text-muted",
									i === 0 && "pl-5",
								)}
							>
								{col.label}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{tasks.map((task) => (
						<tr
							key={task.id}
							className="border-b border-border last:border-0 hover:bg-muted-subtle transition-colors"
						>
							{columns.map((col, i) => (
								<td
									key={col.key}
									className={cn("px-4 py-3.5", i === 0 && "pl-5")}
								>
									{col.cell(task, ctx)}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</Card>
	);
}
